import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Lifter } from "types";
import get from "lodash/get";

const LifterName = ({
  currentLifter,
  id,
}: {
  currentLifter: Lifter | undefined | null;
  id: string;
}) => {
  return (
    <DisplayComponent style={{ top: 0, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 38,
          padding: sizeMultiplier * 12,
          width: sizeMultiplier * 600,
        };

        const lifterName = get(currentLifter, "name", "AAAAAAA AAAAAAA");

        return (
          <div style={style} className="lifter-details">
            {lifterName}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default LifterName;
